import { makeModeConstants } from '../../../../actionCreators/mode';
import { STATION_TITLE } from '../../../../constants';
import type { IMode } from '../../../../ts/interface/mode.interface';

export interface RawSystem {
  id?: string | null;
  oldId?: string | null;
  name?: string | null;
  newHardware?: boolean | null;
  rentableHardwareType?: {
    id?: string | null;
    name?: string | null;
    namePlural?: string | null;
  } | null;
}

export interface LegacySystem {
  id: string;
  gid: string;
  old_id: string;
  name: string;
  new_hardware: boolean;
  hardware_type: string;
  hardware_type_gid: string;
}

export function buildSystemInfo(raw: RawSystem | null | undefined): {
  system: LegacySystem;
  modeInfo: IMode;
} {
  const hwType = raw?.rentableHardwareType ?? null;
  const type = hwType?.name ?? '';
  const typeGid = hwType?.id ?? '';

  const system: LegacySystem = {
    id: raw?.id ?? '',
    gid: raw?.id ?? '',
    old_id: raw?.oldId ?? '',
    name: raw?.name ?? '',
    new_hardware: raw?.newHardware ?? false,
    hardware_type: type,
    hardware_type_gid: typeGid,
  };

  // makeModeConstants returns undefined for hardware types it does not switch
  // on; guarantee a well-formed modeInfo so consumers can read .details safely.
  const modeInfo: IMode =
    (makeModeConstants({
      type,
      type_name: type,
      type_name_plural: hwType?.namePlural ?? '',
      hardware_type_gid: typeGid,
      configuration: null,
    }) as IMode) ?? {
      currentMode: '',
      icon: '',
      details: {
        unitsTitle: type,
        pluralUnits: hwType?.namePlural ?? '',
        hardware_type: type,
        hardware_type_gid: typeGid,
        stationsTitle: STATION_TITLE,
      },
    };

  return { system, modeInfo };
}
